import {
    AfterViewInit,
    Component,
    ComponentRef,
    DestroyRef,
    EnvironmentInjector,
    EventEmitter,
    InjectionToken,
    Injector,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    Provider,
    Type,
    ViewContainerRef,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DefaultRequestErrorComponent } from './default-request-error.component';

export const RequestErrorComponentToken = new InjectionToken<Type<any>>('RequestErrorComponentToken');

export function provideRequestErrorComponent(cmp: typeof DefaultRequestErrorComponent): Provider {
    return {
        provide: RequestErrorComponentToken,
        useValue: cmp,
    } as Provider;
}

@Component({
    selector: 'request-error',
    template: ``,
    standalone: true,
})
export class RequestErrorComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() loadFailed: boolean | string;
    @Input() errorMsg?: string;
    @Input() loginNeed?: boolean | string;
    @Input() insertedPlace?: string;
    @Input() reloadMethods?: string[] = ['RELOAD_COMPONENTS'];
    @Input() showLoginbutton?: boolean = false;

    @Output() readonly reloadFn?: EventEmitter<{}> = new EventEmitter();

    private injector = inject(Injector);
    private envInjector = inject(EnvironmentInjector);
    private destroyRef = inject(DestroyRef);
    private vcr = inject(ViewContainerRef);
    private cmpToken = inject(RequestErrorComponentToken);

    private cmpRef?: ComponentRef<any>;

    ngOnChanges() {
        this.syncInputs();
    }

    ngAfterViewInit() {
        if (!this.cmpToken) {
            throw new Error('Please provide a request-error component!');
        }

        this.cmpRef = this.vcr.createComponent(this.cmpToken, {
            injector: this.injector,
            environmentInjector: this.envInjector,
        });

        this.syncInputs();

        if (this.cmpRef) {
            this.cmpRef.instance.reloadFn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x: any) => {
                this.reloadFn!.emit(x);
            });
        }
    }

    private syncInputs() {
        if (this.cmpRef) {
            this.cmpRef.setInput('loadFailed', this.loadFailed);
            this.cmpRef.setInput('errorMsg', this.errorMsg);
            this.cmpRef.setInput('loginNeed', this.loginNeed);
            this.cmpRef.setInput('insertedPlace', this.insertedPlace);
            this.cmpRef.setInput('reloadMethods', this.reloadMethods);
            this.cmpRef.setInput('showLoginbutton', this.showLoginbutton);
        }
    }

    ngOnDestroy(): void {
        this.cmpRef!.destroy();
    }
}
